import { copyIcon } from "../icons";

const quickPromptSuggestions = [
  {
    title: "Fluxograma",
    prompt: "Fluxograma",
  },
  {
    title: "Diagrama ER",
    prompt: "Diagrama ER",
  },
  {
    title: "Diagrama de classes",
    prompt: "Diagrama de classes",
  },
  {
    title: "Diagrama de sequência",
    prompt: "Diagrama de sequência",
  },
  {
    title: "Diagrama de estado",
    prompt: "Diagrama de estado",
  },
  {
    title: "Fluxo de processo",
    prompt: "Fluxograma",
  },
] as const;

export const TTDWelcomeMessage = ({
  onPromptSelect,
}: {
  onPromptSelect?: (prompt: string) => void;
}) => {
  return (
    <div className="chat-interface__welcome-screen__welcome-message">
      <h3>Descreva o diagrama que você quer criar</h3>
      <p>
        Nós vamos gerar a estrutura para você e ajudar a transformar a ideia
        em um diagrama pronto.
      </p>
      <p>
        Por enquanto, os tipos mais seguros para pedir são Fluxograma,
        Sequência, Classe, Estado e Entidade-Relacionamento.
      </p>
      <p>
        Se quiser, clique em um modelo abaixo e complete só o assunto depois.
      </p>

      <div className="chat-interface__welcome-screen__suggestions">
        <div className="chat-interface__welcome-screen__suggestions__title">
          Modelos rápidos
        </div>
        <div className="chat-interface__welcome-screen__suggestions__hint">
          Clique para copiar o modelo para o campo de texto.
        </div>
        <div className="chat-interface__welcome-screen__suggestions__grid">
          {quickPromptSuggestions.map((suggestion) => (
            <button
              key={suggestion.title}
              type="button"
              className="chat-interface__welcome-screen__suggestion"
              onClick={() => onPromptSelect?.(suggestion.prompt)}
            >
              <span className="chat-interface__welcome-screen__suggestion__title">
                {suggestion.title}
              </span>
              <span
                className="chat-interface__welcome-screen__suggestion__icon"
                aria-hidden="true"
              >
                {copyIcon}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
